export const strMonthMap = {
    "enero": "enero", "ene": "enero", "january": "enero", "jan": "enero",
    "febrero": "febrero", "feb": "febrero", "february": "febrero",
    "marzo": "marzo", "mar": "marzo", "march": "marzo",
    "abril": "abril", "abr": "abril", "april": "abril", "apr": "abril",
    "mayo": "mayo", "may": "mayo",
    "junio": "junio", "jun": "junio", "june": "junio",
    "julio": "julio", "jul": "julio", "july": "julio",
    "agosto": "agosto", "ago": "agosto", "august": "agosto", "aug": "agosto",
    "septiembre": "septiembre", "sep": "septiembre", "sept": "septiembre", "september": "septiembre",
    "octubre": "octubre", "oct": "octubre", "october": "octubre",
    "noviembre": "noviembre", "nov": "noviembre", "november": "noviembre",
    "diciembre": "diciembre", "dic": "diciembre", "december": "diciembre", "dec": "diciembre"
};

export const monthMap = {
    "enero": 0, "febrero": 1, "marzo": 2, "abril": 3, "mayo": 4, "junio": 5,
    "julio": 6, "agosto": 7, "septiembre": 8, "octubre": 9, "noviembre": 10, "diciembre": 11
};

//Sorts an array of "Mes año" labels (e.g. "Enero 2026") chronologically using monthMap
export const sortMonths = (months) => {
    if (!months || !Array.isArray(months) || months.length === 0) {
        return [];
    }

    return [...months].sort((a, b) => {
        const [monthA, yearA] = a.toLowerCase().split(' ');
        const [monthB, yearB] = b.toLowerCase().split(' ');

        if (yearA !== yearB) {
            return parseInt(yearA) - parseInt(yearB);
        }
        return monthMap[monthA] - monthMap[monthB];
    });
}